import styled from 'styled-components/macro';

interface IStyledContainerProps {
  isDragging: boolean;
  isMobile?: boolean;
}

const StyledContainer = styled.div<IStyledContainerProps>`
  width: 100%;
  height: 100%;
  border: 1px solid black;
  pointer-events: ${({ isDragging }: IStyledContainerProps): string => (isDragging ? 'auto' : 'none')};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99999;
`;

export default StyledContainer;
